var path = '/app/components/dialogs/keys/keys.html';
var html = "<div class=custom-modal-wrap> <div class=custom-modal> <div class=modal-header>Chaves Encontradas</div> <div class=keys> <div class=\"key blue\" ng-class=\"{'empty' : !$ctrl.keys[1]}\"></div> <div class=\"key yellow\" ng-class=\"{'empty' : !$ctrl.keys[2]}\"></div> <div class=\"key red\" ng-class=\"{'empty' : !$ctrl.keys[0]}\"></div> <div class=number-keys>{{$ctrl.totalKeys}}</div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/keys/keys.html
// module id = 162
// module chunks = 0